import React, { useEffect, useState } from "react";
import {
  DocumentsSignatureLib,
  recallService,
  useFetch,
} from "clsales-documents-signature-lib";
import "./PlanContracts.scss";
import BackContinue from "./backContinue";
import { WealthService } from "../../services/";
import { useAppContext } from "../../context/AppContext";
import CONFIG from "../../config";
import { RetryErrorComponent } from "../../components";

const PlanContracts = ({ changeContextClientStep }) => {
  const [canContinue, setCanContinue] = useState(false);
  const [generateDocumentsServiceAgain, setGenerateDocumentsServiceAgain] =
    useState(null);
  let generateDocumentsInterval;
  const wealthService = new WealthService();
  const {
    changeItem: setContext,
    state: context,
    displayError,
  } = useAppContext();
  const dataPostBody = {
    app_path: CONFIG.API.BCDocumentAPI,
    client_id: context.agentSubject,
    documents: ["kyc", "seg191", "seg047"],
  };

  const [consent, setConsent] = useState({
    auth_type: "",
    consent_text: "Cargando...",
    creation_time: "",
    is_active: "",
    sign_provider: "",
    version: "",
  });

  const { isLoading: isLoadingSign, fetchData } = useFetch({
    url: "/sign",
    data: dataPostBody,
  });

  const getConsent = () => {
    setContext({ loading: true });
    wealthService
      .consent({
        channel: "WPUB",
        product: "WEALTH",
        flowType: "ONBOARDING_WEALTH_CUSTOMER",
        consentType: "GENERAL",
        productName: "SIGN_DOCUMENTS",
      })
      .then((res) => {
        let value = res;
        let row = value[0];
        setConsent({
          auth_type: row.auth_type,
          consent_text: row.consent_text,
          creation_time: row.creation_time,
          is_active: row.is_active,
          sign_provider: row.sign_provider,
          version: row.version,
        });
      })
      .catch((error) => {
        displayError(
          error,
          getConsent,
          <RetryErrorComponent retryCallBack={getConsent} />
        );
      })
      .finally(() => {
        setContext({ loading: false });
      });
  };

  useEffect(() => {
    recallService(
      generateDocumentsInterval,
      generateDocumentsServiceAgain,
      handleContinue
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generateDocumentsServiceAgain]);

  useEffect(() => {
    setContext({
      checkedStep: {
        ...context.checkedStep,
        planContracts: canContinue,
      },
    });

    getConsent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canContinue]);

  const handleContinue = async () => {
    try {
      const resp = await fetchData();
      handleResp(resp);
    } catch (e) {
      console.log(e);
    }
  };

  const handleResp = async (resp) => {
    if (resp?.status === "OK") {
      clearTimeout(generateDocumentsInterval);
      await fetchProduct();
      await fetchConsentSubject();
      changeContextClientStep("accountCreate");
    } else if (resp?.status === "PENDING") {
      setGenerateDocumentsServiceAgain(new Date().getTime());
    }
  };

  const fetchProduct = async () => {
    setContext({ loading: true });
    await wealthService
      .createProduct(context.subjectId)
      .then((res) => {})
      .catch((error) => {
        displayError(error);
      })
      .finally(() => {
        setContext({ loading: false });
      });
    setContext({ loading: false });
  };

  const ifConcertData = () => {
    if (context.checkedStep.planContracts) {
      return true;
    } else {
      return false;
    }
  };

  const fetchConsentSubject = async () => {
    setContext({ loading: true });
    if (ifConcertData) {
      await wealthService
        .consentSave({
          customer_id: context.subjectData.rut,
          customer_ip: "",
          channel_type: "WPUB",
          product_type: "WEALTH",
          flow_type: "ONBOARDING_WEALTH_CUSTOMER",
          consent_type: "GENERAL",
          product_name: "SIGN_DOCUMENTS",
          version: consent.version,
        })
        .then((res) => {
          setContext({
            agentSubject: res.subject_id,
          });
        })
        .catch((error) => {
          displayError(error, fetchConsentSubject());
        })
        .finally(() => {
          setContext({ loading: false });
        });
    }
    setContext({ loading: false });
  };

  return (
    <div className="plan_contracts-step">
      <DocumentsSignatureLib
        documentsRequestBody={dataPostBody}
        dark={true}
        setCanContinue={setCanContinue}
        mainTitle="Revisa y firma los siguientes documentos:"
        termsAndConditionsOptions={termsAndConditionsOptions}
      />
      <BackContinue
        goBack={() => {}}
        canContinue={canContinue}
        handleContinue={handleContinue}
        isLoading={isLoadingSign}
      />
    </div>
  );
};
export default PlanContracts;

const termsAndConditionsOptions = {
  title: "Envío de comprobante y requisitos regulatorios",
  subtitle:
    "Para tu respaldo, enviaremos un comprobante de la solicitud de abono de remuneraciones.",
  checkLabel: (
    <>
      Acepto los <b>Términos y Condiciones,</b> planteados en los documentos
      asociados a Scotia Wealth Management.
    </>
  ),
  alert: {
    title: "Términos y Condiciones",
    type: "info",
    content: (
      <>
        Recuerda que podrás aceptar siempre y cuando{" "}
        <b>revises el documento completo.</b>
      </>
    ),
  },
};
